import React, { useState, useCallback } from 'react';
import { Lightbox } from './Lightbox';
import '../Styles/Gallery.css';

const GalleryItem = ({ src, index, onClick }) => {
	const [loaded, setLoaded] = useState(false);

	return (
		<div 
			className={`image-loader-container ${loaded ? 'loaded' : 'loading'}`} 
			onClick={onClick}
		>
			<img 
				src={src} 
				alt={`Work ${index + 1}`} 
				loading="lazy" 
				onLoad={() => setLoaded(true)}
				className={loaded ? 'faded-in' : 'hidden'}
			/>
		</div>
	);
};

export function Gallery() {
	const [currentIndex, setCurrentIndex] = useState(null);
	const totalImages = 20; 
	const images = Array.from({ length: totalImages }, (_, i) => `/Images/Gallery/${i + 1}.png`);

	const nextImage = useCallback(() => {
		setCurrentIndex((prev) => (prev + 1) % images.length);
	}, [images.length]);

	const prevImage = useCallback(() => {
		setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
	}, [images.length]);

	return (
		<div className="gallery-view">
			<div className="gallery-grid">
				{images.map((src, index) => (
					<GalleryItem 
						key={index} 
						src={src} 
						index={index} 
						onClick={() => setCurrentIndex(index)} 
					/>
				))}
			</div>

			{currentIndex !== null && (
				<Lightbox 
					images={images}
					currentIndex={currentIndex}
					onClose={() => setCurrentIndex(null)}
					onNext={nextImage}
					onPrev={prevImage}
				/>
			)}
		</div>
	);
}